<template>
  <card>
    <h4>Заблокировано устройств</h4>
    <list
      v-if="$store.state.user.sections['subscriptions']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {
        subscription_status: "block",
        per_page: 10,
      },
      val: [],
      modalCreate: "season",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "report/subscriptions",
      setLink: "report/subscriptions",
      columns: [
        {
          key: "id",
          title: "Номер",
          full: true,
        },
        {
          key: "phone_control",
          title: "Номер абонента",
          full: true,
        },

        {
          key: "imeis",
          title: "Дата подписки",
          disableLink: true,
          full: true,
          object: "number",
        },
        {
          key: "user_fullname",
          title: "ФИО",
          full: true,
        },
        {
          key: "shop",
          object: "name",
          title: "Офис",
          disableLink: true,

          full: true,
        },
        {
          key: "user_passport",
          title: "Паспорт",
          full: true,
        },
        {
          key: "start_date",
          title: "Дата подписки",
          disableLink: true,
          dateFormat: true,
        },
        // {
        //   key: "subscription_status",
        //   object: "time",
        //   title: "Дата блокировки",
        //   disableLink: true,
        //   dateTimeFormat: true,
        //   full: true,
        // },
      ],
    };
  },
};
</script>
<style>
</style>
